import {FormControl, FormField, FormItem, FormLabel, FormMessage} from "@/components/ui/form";
import {Popover, PopoverContent, PopoverTrigger} from "@/components/ui/popover";
import {CalendarIcon} from "@radix-ui/react-icons";
import {format} from "date-fns";
import {fr} from "date-fns/locale";
import {cn} from "@/lib/utils";
import {Button} from "@/components/ui/button";
import {Calendar} from "@/components/ui/calendar";


export default function CWFDatePicker({className, control, name, label, future, disabled,modal = false,...props}) {
    return (
        <FormField
            control={control}
            name={name}
            render={({field}) => (
                <FormItem className={cn("grid w-full items-center h-max gap-1.5 space-y-0", className)}>
                    {label && <FormLabel>{label}</FormLabel>}
                    <Popover modal={modal}>
                        <PopoverTrigger asChild>
                            <FormControl>
                                <Button
                                    variant={"outline"}
                                    className={cn(
                                        "w-full pl-3 text-left font-normal disabled:cursor-not-allowed",
                                        !field.value && "text-muted-foreground"
                                    )}
                                    disabled={disabled}
                                >
                                    {field.value ? (
                                        format(field.value, "PPP", {locale: fr})
                                    ) : (
                                        <span>Choisissez une date</span>
                                    )}
                                    <CalendarIcon className="ml-auto h-4 w-4 opacity-50" />
                                </Button>
                            </FormControl>
                        </PopoverTrigger>
                        <PopoverContent className="w-auto p-0" align="start">
                            <Calendar
                                mode="single"
                                selected={field.value}
                                onSelect={field.onChange}
                                disabled={(date) => future && date < new Date(Date.now())}
                                initialFocus
                                {...props}
                            />
                        </PopoverContent>
                    </Popover>
                    <FormMessage />
                </FormItem>
            )}
        />
    );

}
